module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    ref: "popper",
    staticClass: "tooltip"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-arrow",
    attrs: {
      "x-arrow": ""
    }
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-793de3ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltip/Tooltip.vue
// module id = 349
// module chunks = 0